<template lang="pug">
  .dashboard-container.services-content
    h5.pt-5.pl-3 {{ t('components.access_services.acceso').toUpperCase() }}
    .row.service-row
      .service.col-lg-4.col-md-6.d-flex.p-0.justify-content-center(
        v-for="button in buttons"
        :key="button.name"
      )
        a.btn.button-services.mt-4.text-left(:href="button.url" :target="linkTarget(button)" v-bind="trackData(button)")
          b {{ linkText(button) }}
          img(:src="iconPath(button.icon)" alt="icon")
</template>

<script>
  import mixins from 'common/mixins'

  export default {
    name: 'access-services-vue',
    mixins: [mixins.translate],
    props: {
      buttons: {
        type: Array,
        default: () => []
      },
      statsEnabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      iconPath(icon){
        return '/base/assets/conmex/' + icon + '.png'
      },
      linkText(button) {
        return this.t('components.access_services.buttons.' + button.name)
      },
      linkTarget(button) {
        return button.new_tab ? '_blank' : ''
      },
      trackData(button) {
        if (!this.statsEnabled) return {}

        return {
          'data-track-category': this.trackValue('tracking.home.category'),
          'data-track-action': this.trackValue('tracking.home.solutions'),
          'data-track-name':
            this.trackValue('components.access_services.buttons.' + button.name)
        }
      },
      trackValue(valueId) {
        return this.t(valueId, { locale: 'es' })
      }
    }
  }
</script>
